import { render, staticRenderFns } from "./TicketsView.vue?vue&type=template&id=ace7d9b2&scoped=true&lang=pug&"
import script from "./TicketsView.vue?vue&type=script&lang=js&"
export * from "./TicketsView.vue?vue&type=script&lang=js&"
import style0 from "./TicketsView.vue?vue&type=style&index=0&id=ace7d9b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace7d9b2",
  null
  
)

export default component.exports